import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import Label, { DisplayLabel } from "../ui/Label";
import { pubCall, pubCallAsync } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import POSList from "../components/POSList";
import Input from "../ui/Input";
import Float from "../ui/Float";
import POSDetails from "../components/POSDetails";
import Nav from "../ui/Nav";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import POSItems from "../components/POSItems";
import POSEdit from "../components/POSEdit";
import { createScreen } from "../hooks/createScreen";
import { TRANSACTION } from "../utils/Struct";
import { drawPicker } from "../popovers/Picker";
import { ENUMS } from "../utils/Enums";
import Cookies from "js-cookie";
import { drawPrice, requestClerkCode, requestPrompt, showConfirm, showLogin, stringToFile } from "../utils/Utils";
import POSSearch from "../components/POSSearch";
import { createModal } from "../hooks/createModal";
import Spin from "../ui/Spin";
import POSTender from "../components/POSTender";
import { createEmpty } from "../hooks/createEmpty";
import InventoryDetails from "../components/InventoryDetails";
import { getSignal } from "../App";

export const pos_startNewTransaction = (params, callback = () => { }, async = false) => {
    const { header = false, item = false, check_onhands = false, employee = "" } = params
    let _obj = { header: header, check_onhands: check_onhands, clerk_code: employee }
    if (item) { _obj.item = item; }

    const endpoint = "point_of_sale.startNewTransaction";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_addItem = ({ invoice = "", check_onhands = false, item, employee = "" }, callback = () => { }, async = false) => {
    let _obj = { invoice: invoice, clerk_code: employee, item: item, check_onhands }
    const endpoint = "point_of_sale.addItem";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_editItem = ({ item, employee = "" }, callback = () => { }, async = false) => {
    let _obj = { clerk_code: employee, item: item }
    const endpoint = "point_of_sale.editItem";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_removeItem = ({ point_of_sale_id = "", employee = "" }, callback = () => { }, async = false) => {
    let _obj = { point_of_sale_id: point_of_sale_id, clerk_code: employee }
    const endpoint = "point_of_sale.removeItem";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_deleteTransaction = ({ invoice = "" }, callback = () => { }, async = false) => {
    let _obj = { invoice: invoice };
    const endpoint = "point_of_sale.deleteTransaction";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_copyTransaction = ({ invoice = "" }, callback = () => { }, async = false) => {
    let _obj = { invoice: invoice, require_clerk_code: true };
    const endpoint = "point_of_sale.copyTransaction";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_editHeader = ({ header = "", employee = "" }, callback = () => { }, async = false) => {
    let _obj = { header: header, clerk_code: employee };
    const endpoint = "point_of_sale.editHeader";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}


// export const pos_removeItem = (params, callback = () => {}, async = false) =>{
//      let _obj = { invoice: invoice, require_clerk_code: true };
// }

export default function POSController(props) {

    const { controller = "", signal = {}, setController = () => { } } = props;

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedFull, setSelectedFull] = useState({})
    const [selectedItem, setSelectedItem] = useState({});
    const [items, setItems] = useState([]);
    const [align, setAlign] = useState("start");
    const row_key = "posh_id";
    const employee = useRef("");
    const [state, setState] = useState({
        edit: false,
        adding: false,
        view: "items",
        show_pos_card: true,
        new_title: false
    })

    const returnFromInventoryRef = useRef(null);
    const callbackRef = useRef(() => { });
    const prev_row_fallback = useRef({});

    const showPOSDetails = state.view === "list" || state.show_pos_card || selectedItem?.__new;

    const toggleDetailCard = () => {
        if (selectedItem?.__new) {
            setState(s => ({ ...s, show_pos_card: true }));
            return;
        }

        setState(s => ({
            ...s,
            show_pos_card: !s.show_pos_card,
        }));
    };

    const toggleView = () => {
        if (state.view === "list") {
            // window.bm_state.value = ROUTES.POS.ITEMS;
            setState(s => ({ ...s, view: "items", show_pos_card: true }));
        } else {
            window.bm_state.value = ROUTES.POS.POS;
            setState(s => ({ ...s, view: "list", show_pos_card: true }));

        }

    };

    const copyTransaction = (_transaction = selected) => {
        setLoading(true);
        pos_copyTransaction({ invoice: _transaction?.invoice }, (_s, _r) => {
            if (_s) {
                Cookies.set("pos_id", _r.posh_id);
                fetch()
            } else {
                showError(_r);
            }
        })
    }

    const deleteTransaction = (_transaction = selected, callback = () => { }) => {

        if (_transaction?.stage === "History") {
            showError({ error: "Can't delete a History transaction (it has been totalled off)" });
            return;
        }


        showConfirm({
            controller: controller,
            route: ROUTES.POS.POS,
            description: <div style={{ "textAlign": "center" }}>Delete this <em>{_transaction?.stage || ""}</em> transaction?</div>,
            title: "Warning",
            callback: (e) => {
                if (e) {
                    pos_deleteTransaction({ invoice: _transaction?.invoice }, (_s, _r) => {
                        if (_s) {
                            showMessage("Transaction deleted.")
                            const updated = data.filter(item => item[row_key] !== _transaction?.[row_key])
                            const deleted = data.findIndex(row => row[row_key] === _transaction?.[row_key]);
                            setData(updated);
                            setSelected(updated[deleted - 1] || updated[0] || {});
                        } else {
                            showError(_r);
                        }
                        callback(_r)
                    })
                }
            }
        })
    }


    const printItem = (_str) => {
        stringToFile("file", _str, "txt");
    }

    const showTender = (header) => {

        const return_route = window.bm_state.value;
        window.bm_state.value = ROUTES.POS.TENDER;


        createScreen({
            signal: getSignal(),
            component: <POSTender controller={controller} employee={employee?.current || ""} header={header} items={items} invoice={header?.invoice} route={ROUTES.POS.TENDER} />, closable: false, title: "Select Customer",
            callback: (_obj) => {


                if (_obj === "exit") {
                    setState({ ...state, edit: false, adding: false, view: "items" })
                    window.bm_state.value = return_route;
                    return;
                }

                if (_obj) {

                    if (_obj?.print_previews?.length) {
                        _obj.print_previews.forEach(element => {
                            printItem(element)
                        });
                    }

                    window.bm_state.value = ROUTES.POS.POS;
                    const _new = { ..._obj?.extras?.header, "flag": true, invoice: _obj.invoice };
                    setItems(_obj?.extras?.items_first)
                    setState({ ...state, edit: false, adding: false, view: "items" })

                    let _d = [...data];
                    _d.push(_new)
                    setData(_d);
                    setSelected(_new);

                    return;
                }

                window.bm_state.value = return_route;
                console.log(data)

                setSelected((data.length > 0) ? data[data.length - 1] : {})

            }
        });


    }


    const [titleEdit, setTitleEdit] = useState(false);

    const editTitle = () => {
        window.bm_state.value = ROUTES.INVENTORY.EDIT;
        setState(s => ({
            ...s,
            show_pos_card: false,
            new_title: false,
        }));
        setTitleEdit(true);
    };

    const addTitle = (_item, callback = () => { }) => {

        callbackRef.current = callback;

        pubCall("title_link.search", { limit: 1, term: _item.primary_code, type: "isbn", scope: "both", sort: "rank" }, (_s, _r) => {
            if (_s) {
                if (_r.rows.length > 0) {

                    returnFromInventoryRef.current = {
                        route: window.bm_state.value,
                        state: {
                            view: state.view,
                            show_pos_card: state.show_pos_card,
                            edit: state.edit,
                            adding: state.adding,
                        },
                    };

                    window.bm_state.value = ROUTES.INVENTORY.EDIT;
                    setState({ ...state, show_pos_card: false, new_title: _r.rows[0]?.title_link || {} })
                    setTitleEdit(true);
                } else {
                    showError({ error: "Title not found." });
                }
            } else {
                showError(_r.error)
            }
        })

    }

    const closeEdit = (stock = false) => {
        const returnState = returnFromInventoryRef.current;

        if (!returnState) {
            setTitleEdit(false);
            setState(s => ({
                ...s,
                show_pos_card: true,
                new_title: null,
            }));
            return;
        }

        window.bm_state.value = returnState.route;

        setTitleEdit(false);

        setState(s => ({
            ...s,
            ...returnState.state,
            new_title: null,
        }));

        returnFromInventoryRef.current = null;
        callbackRef.current(stock);
        callbackRef.current = () => { };

    };

    const pos_nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },

        { key: KBD.C, text: "Cpy", action: () => copyTransaction() },
        { key: KBD.D, text: "Del", action: () => deleteTransaction() },
        { key: KBD.E, text: "Edt", action: () => editTransaction() },
        { key: KBD.ALT_E, text: "@Edt", action: () => { } },
        { text: "GftRct" },
        { text: "Hist" },
        { text: "Log" },
        { text: "Misc" },
        { key: KBD.N, text: "New", action: () => newTransaction() },
        { text: "Prt" },
        { text: "Qsls" },
        { key: KBD.S, text: "Srch", action: () => showSearch() },
        { key: KBD.T, text: "Ttl", action: () => showTender() },
        { text: "Xtra" },
        { text: "Web" },
        { text: "Znosale" },
        { key: KBD.V, text: "View", action: () => toggleView() },
    ]

    useEffect(() => {
        window.bm_state.value = ROUTES.POS.POS;
    }, [])

    useEffect(() => {

        const cleanup = listen(controller, ROUTES.POS.POS, pos_nav);
        return cleanup;
    }, [pos_nav, state])


    useEffect(() => {
        if (selected?.[row_key]) {
            Cookies.set("pos_id", selected?.[row_key]);
        }
    }, [selected])





    const showSearch = () => {
        window.bm_state.value = ROUTES.POS.SEARCH;
        createModal({

            component: <POSSearch controller={controller} setSelected={setSelected} selected={selected} route={ROUTES.POS.SEARCH} />, closable: true, title: "POS Search",
            callback: (e, _searchMsg) => {
                if (e?.posh_id) {
                    Cookies.set("pos_id", e.posh_id);
                    fetch();
                }
                window.bm_state.value = ROUTES.POS.POS
            }
        });
    }


    // useEffect(() => {

    //     if (!selected?.invoice || state.view !== "list") { return; }

    //     pubCall("point_of_sale.getSingleHeader", { invoice: selected?.invoice }, (_s, _r) => {
    //         if (_s) {
    //             setData(prev =>
    //                 prev.map(row =>
    //                     row[row_key] === _r[row_key]
    //                         ? { ...row, name: "New Name" }
    //                         : row
    //                 )
    //             );
    //         } else {
    //             showError(_r);
    //         }
    //     })

    // }, [selected?.invoice])




    const newTransaction = () => {

        prev_row_fallback.current = selected || {};

        requestClerkCode({
            route: window.bm_state.value,
            login: false,
            use_login: false,
            signal: signal,
            title: "Login required",
            callback: (e) => {
                if (e) {
                    // set employee

                    employee.current = e;
                    window.bm_state.value = ROUTES.POS.EDIT;
                    const transaction = { ...TRANSACTION };

                    setSelected(transaction.header);
                    setSelectedFull({ header: transaction.header, items_first: [] })
                    setTimeout(() => {
                        setState({ ...state, "view": "items", edit: true, adding: true })
                    }, 10)
                }
            }
        })
    }


    const editHeader = () => {
        alert("TODO")
    }


    const editTransaction = () => {

        if (selected?.stage === "History") {
            showError({ error: "Can't alter a History transaction (it has been totalled off)" });
            return;
        }



        requestClerkCode({
            route: window.bm_state.value,
            login: false,
            use_login: false,
            signal: signal,
            title: "Login required",
            callback: (e) => {
                if (e) {
                    employee.current = e;
                    window.bm_state.value = ROUTES.POS.EDIT;

                    setState(s => ({
                        ...s,
                        view: "items",
                        edit: true,
                        adding: false,
                        show_pos_card: true,
                    }));
                }
            }
        });
    }


    const getSelectedFull = () => {
        if (!selected?.invoice || selected?.flag) {
            return;
        }
        pubCall("point_of_sale.getHeaderExtras", { invoice: selected?.invoice }, (_s, _r) => {
            if (_s) {
                setSelectedFull(_r);
            } else {
                showError(_r)
            }
        })
    }
    useEffect(getSelectedFull, [selected])

    const cancelEdit = (_ref, _return_route) => {


        if (!selected?.invoice) {
            // not created yet
            window.bm_state.value = ROUTES.POS.POS;
            setState({ ...state, edit: false, adding: false, view: "items" });
            setSelected(prev_row_fallback.current);
            return
        }


        if (_ref && typeof _ref?.blur === "function") {
            _ref.blur();
        }

        drawPicker({
            controller: controller,
            value: "R", title: "Select Status", closeable: true, height: 300, ref: null,
            close: () => {
                window.bm_state.value = _return_route;
                if (_ref && typeof _ref?.focus === "function") {
                    _ref.focus();
                }

            },
            callback: (e) => {


                switch (e) {
                    case "R":
                        window.bm_state.value = _return_route;
                        if (_ref && typeof _ref?.focus === "function") {
                            _ref.focus();
                        }
                        return;
                        break;
                    case "H":
                        window.bm_state.value = ROUTES.POS.POS;
                        setState({ ...state, edit: false, adding: false, view: "items" });
                        break;
                    case "Q":
                        showError({ error: "TODO - Convert to Quote" })
                        window.bm_state.value = _return_route;
                        if (_ref && typeof _ref?.focus === "function") {
                            _ref.focus();
                        }
                        break;
                    case "D":
                        deleteTransaction(selected, (_r) => {
                            window.bm_state.value = ROUTES.POS.POS;
                            setState({ ...state, edit: false, adding: false, view: "items" });
                        })
                        return;
                        break;
                }



            }, offset: [0, 10],
            options: ENUMS.TRANSACTION_INTERUPTED
        })
    }


    const fetchLast = (_filters = {}) => {
        setLoading(true);
        pubCall("point_of_sale.getLastHeader", _filters, (_s, _r) => {
            if (_s) {
                if (_r.length > 0) {
                    setAlign("end");
                }
                setData(_r);
                setSelected((_r.length > 0) ? _r[_r.length - 1] : {})

            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const fetch = () => {
        if (loading || state.edit) { return }

        let _filters = {};
        _filters.limit = 45;
        if (selected?.[row_key]) {
            _filters[row_key] = selected?.[row_key];
        }

        // remember the last one...
        if (Cookies.get("pos_id")) {
            setLoading(true);
            _filters.posh_id = Cookies.get("pos_id");
            // _filters.posh_id = "019df99a-3b37-72b4-b7b4-5d24666670b8"
            pubCall("point_of_sale.getInitialHeader", _filters, (_s, _r) => {
                if (_s) {



                    setData(_r.rows_previous.concat(_r.rows_next));
                    setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : (_r.rows_previous.length > 0) ? _r.rows_previous[_r.rows_previous.length - 1] : {})


                } else {
                    fetchLast(_filters);
                }
                setLoading(false)
            })
        } else {
            fetchLast(_filters);
        }

    }

    useEffect(fetch, []);



    const updateTransaction = (header, item = false) => {



    }

    const stock_edit = window.bm_state.value === ROUTES.INVENTORY.EDIT;

    return (
        <div className="controller">
            <Spin loading={loading}>
                <div style={{ height: "calc(100vh - 74px)", minHeight: "557px", gap: "15px" }}>
                    {showPOSDetails ? (
                        <POSDetails
                            employee={employee?.current}
                            controller={controller}
                            selected={selected}
                            setSelected={setSelected}
                            selectedItem={selectedItem}
                            state={state}
                            setState={setState}
                            cancelEdit={cancelEdit}
                        />
                    ) : (
                        <InventoryDetails
                            edit={titleEdit}
                            new_obj={state.new_title}
                            isnew={!!state.new_title}
                            {...selectedItem}
                            switchEdit={(stock) => closeEdit(stock)}
                        />
                    )}


                    <div className="shim" />



                    <POSList
                        row_key={row_key}
                        controller={controller}
                        loading={loading}
                        setLoading={setLoading}
                        route={ROUTES.POS.POS}
                        data={data}
                        setData={setData}
                        selected={selected}
                        setSelected={setSelected}
                        signal={signal}
                        align={align}
                        setAlign={setAlign}
                        state={state}
                        setState={setState}
                    />


                    {((state?.view === "items" || state?.view === "customer") &&
                        <POSItems
                            fetch={fetch}
                            closeEdit={closeEdit}
                            editTitle={editTitle}
                            addTitle={addTitle}
                            setSelectedItem={setSelectedItem}
                            editTransaction={editTransaction}
                            toggleView={toggleView}
                            showTender={showTender}
                            employee={employee?.current}
                            header={selectedFull?.header || (selected?.header || {})}
                            items={items}
                            setItems={setItems}
                            setHeader={setSelected}
                            controller={controller}
                            addNewRow={(item) => {
                                setData(prev => [...prev, item]);
                            }}
                            state={state}
                            setState={setState}
                            loading={loading}
                            setLoading={setLoading}
                            route={ROUTES.POS.EDIT}
                            signal={signal}
                            cancelEdit={cancelEdit}
                        />
                    )}

                    {(!state.adding && !state.edit) &&
                        <>
                            <div className="shim" />
                            <Divider />
                            <div style={{ 'height': "30px" }}>

                                <Space style={{ "padding": "0px 15px" }}>
                                    <Nav nav={pos_nav} />
                                </Space>

                            </div>
                        </>
                    }

                </div>

                {(selected?.flag &&
                    <div style={{ "position": "absolute", "bottom": "50px", "right": "0px", "width": "400px" }}>
                        <Card secondary style={{ "width": "auto", "padding": "5px 15px", "height": "94px", "backgroundColor": "var(--card-bg)", "borderRadius": "5px", "border": "2px solid var(--text-purple)" }}>
                            <Label style={{ "color": "var(--text)" }}>{<>Transaction complete</>}</Label>
                            <div style={{ "fontSize": "55px", "textAlign": "right", "fontWeight": "bold" }}>${drawPrice(2540, true)}</div>
                        </Card>
                    </div>
                )}


            </Spin>
        </div>
    )
}